
import { tx, lz } from "@/i18n";export const KEY_NONE = "__leeg__";

// Fixed dropdown options for the "set" columns (incl. emphasis "!" variants).
export const KEY_OPTIONS = [
  "Nathalie", "Nathalie!", "Maike", "Maike!", "Serge", "Serge!",
  "Nathalie + Serge", "Gasten!", "NVT", "TYLB", "Kenneth & Fran", "Selima",
  "Lycke", "Lycke!",
];

export const BEHEERDER_OPTIONS = ["Nathalie", "Maike", "Serge", "Nathalie + Serge", "Lycke"];

const PEOPLE = ["Nathalie", "Maike", "Serge", "Lycke"];

const COLOR = {
  "Nathalie": "bg-purple-100 text-purple-700 border-purple-200",
  "Maike": "bg-blue-100 text-blue-700 border-blue-200",
  "Serge": "bg-emerald-100 text-emerald-700 border-emerald-200",
  "Nathalie + Serge": "bg-violet-100 text-violet-700 border-violet-200",
  "Gasten!": "bg-orange-100 text-orange-700 border-orange-200",
  "NVT": "bg-gray-100 text-gray-500 border-gray-200",
  "TYLB": "bg-yellow-100 text-yellow-800 border-yellow-200",
  "Kenneth & Fran": "bg-pink-100 text-pink-700 border-pink-200",
  "Selima": "bg-teal-100 text-teal-700 border-teal-200",
  "Lycke": "bg-cyan-100 text-cyan-700 border-cyan-300",
};

export function keyClasses(value) {
  if (!value) return "";
  const emphasis = value.endsWith("!") && PEOPLE.includes(value.slice(0, -1));
  const base = emphasis ? value.slice(0, -1) : value;
  const color = COLOR[base] || COLOR[value] || "bg-gray-100 text-gray-600 border-gray-200";
  return `${color}${emphasis ? " ring-1 ring-red-500 border-red-500" : ""}`;
}

// Short label for mobile: first letter(s) of person names; keep short all-caps codes (NVT/TYLB) as-is.
export function shortLabel(value) {
  if (!value) return "";
  const emphasis = value.endsWith("!");
  const core = emphasis ? value.slice(0, -1) : value;
  if (core === core.toUpperCase() && core.length <= 4) return value; // NVT, TYLB
  const parts = core.split(/\s*[+&]\s*/).filter(Boolean);
  const sep = core.includes("+") ? "+" : core.includes("&") ? "&" : "";
  const initials = parts.map((p) => p.trim()[0]?.toUpperCase() || "").join(sep);
  return initials + (emphasis ? "!" : "");
}

export function KeyBadge({ value, testid, plain = false }) {
  if (!value) return <span className="text-muted-foreground">—</span>;
  if (plain) {
    return (
      <span data-testid={testid} title={value} className="inline-flex items-center text-[11px] sm:text-sm font-medium text-foreground/80">
        <span className="sm:hidden">{shortLabel(value)}</span>
        <span className="hidden sm:inline">{value}</span>
      </span>
    );
  }
  return (
    <span data-testid={testid} title={value} className={`inline-flex items-center rounded-full border px-1 sm:px-2.5 py-0.5 text-[11px] sm:text-xs font-semibold ${keyClasses(value)}`}>
      <span className="sm:hidden">{shortLabel(value)}</span>
      <span className="hidden sm:inline">{value}</span>
    </span>
  );
}
